/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

M.View = M.View || {};

/**
 * @class M.View.DatePicker
 *
 * Renders three drop down lists that allow a user to pick a date.
 *
 * Note: This view is different to the jQueryUI datepicker widget
 * http://jqueryui.com/datepicker
 *
 */

M.View.DatePicker = Backbone.View.extend({
  tagName: 'div',

  className: 'datePicker',

  events: {
    'change .daySelect': '_setDay',
    'change .monthSelect': '_setMonth',
    'change .yearSelect': '_setYear',
    'click .changeDate': '_displayPicker'
  },

  template: M.Template.DatePicker.Picker,

  initialize: function() {
    this.$el = $(this.el);
  },

  render: function() {
    var that = this;

    var monthName = this.model.get('monthNames')
      [this.model.getSelectedDate().getMonth()];
    var dayOfMonth = this.model.getSelectedDate().getDate();
    var fullYear = this.model.getSelectedDate().getFullYear();

    this.$el.html(this.template({
      shouldDisplayDateLabel: this.model.get('shouldDisplayDateLabel'),
      dayOfMonth: dayOfMonth,
      monthName: monthName,
      fullYear: fullYear,
      showYear: this.model.get('showYear')
    }));

    this._buildDays();
    this._buildMonths();
    this._buildYears();

    return this;
  },

  _setDay: function(e) {
    var $element = $(e.target);
    this.model.set({'selectedDay': $element.val()});
  },
  _setMonth: function(e) {
    var $element = $(e.target);
    this.model.set({'selectedMonth': $element.val()});
    this._buildDays();
  },
  _setYear: function(e) {
    var $element = $(e.target);
    this.model.set({'selectedYear': $element.val()});
    this._buildDays();
  },

  _displayPicker: function() {
    this.$el.find('.pickerWrap').show();
    this.$el.find('.dateLabel').hide();
  },

  _buildDays: function() {
    var selectedDay = this.model.get('selectedDay');
    var daysInMonth = this.model.getDaysInMonth();
    var $dropDown = this.$el.find('.daySelect');
    $dropDown.empty();
    // TODO: HTML-escape these values
    $dropDown.append('<option value="-1">day</option>');
    for (var i = 1; i <= daysInMonth; i++) {
      var $item = $('<option value="' + i + '">' + i + '</option>');
      if (i == selectedDay) {
        $item.attr('selected', 'selected');
      }
      $dropDown.append($item);
    }
    //set selectedDay to 1 if it is currently greater than maxDays
    if (selectedDay > daysInMonth) {
      this.model.set({'selectedDay': 1});
    }
  },
  _buildMonths: function() {
    var $dropDown = this.$el.find('.monthSelect');
    var monthNames = this.model.get('monthNames');
    $dropDown.empty();
    $dropDown.append('<option value="-1">month</option>');
    for (var i = 0; i < monthNames.length; i++) {
      var $item = $('<option value="' + i + '">' + monthNames[i] + '</option>');
      if (i == this.model.get('selectedMonth')) {
        $item.attr('selected', 'selected');
      }
      $dropDown.append($item);
    }
  },
  _buildYears: function() {
    var $dropDown = this.$el.find('.yearSelect');
    $dropDown.empty();
    $dropDown.append('<option value="-1">year</option>');
    if (this.model.get('reverseYearOrder')) {
      for (var i = this.model.get('maxYear'); i >= this.model.get('minYear'); i--) {
        var $item = $('<option value="' + i + '">' + i + '</option>');
        if (i == this.model.get('selectedYear')) {
          $item.attr('selected', 'selected');
        }
        $dropDown.append($item);
      }
    } else {
       for (var i = this.model.get('minYear'); i <= this.model.get('maxYear'); i++) {
        var $item = $('<option value="' + i + '">' + i + '</option>');
        if (i == this.model.get('selectedYear')) {
          $item.attr('selected', 'selected');
        }
        $dropDown.append($item);
      }
    }
  }
});
